import { Check, Copy } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";

export default function ApiTokenTag({ tokenId }: { tokenId: string }) {
  const [isCopied, setIsCopied] = useState(false);

  function onCopy() {
    navigator.clipboard.writeText(tokenId).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    });
  }

  return (
    <div className="flex items-center gap-x-1">
      <Tag variant="tertiary">
        {`${tokenId.slice(0, 13)}...${tokenId.slice(-2)}`}
      </Tag>
      <Button
        size="xs"
        intent="iconOnly"
        variant="outline-black"
        onClick={onCopy}
      >
        {isCopied ? <Check /> : <Copy />}
      </Button>
    </div>
  );
}
